/**
 * conveys how the collateral should be/has been applied
 * tag: 1043
 * @readonly
 * @enum {number} (int)
 */
export enum CollApplType {
  /** Specific Deposit */
  SpecificDeposit = 0,
  /** General */
  General = 1,
}
